/**
 * Org roles, stored in Auth custom claims as short codes to stay well
 * under the 1000-byte claims limit: { o: { <orgId>: <RoleCode> } }.
 */
export const ROLE_CODES = {
    admin: 'a',
    editor: 'e',
    finance: 'f',
    field: 'd',
    reviewer: 'r',
    board: 'b',
    viewer: 'v',
};
export const CODE_TO_ROLE = Object.fromEntries(Object.entries(ROLE_CODES).map(([role, code]) => [code, role]));
export const ROLE_LABELS = {
    admin: 'Administrator',
    editor: 'Editor',
    finance: 'Finance',
    field: 'Field Officer',
    reviewer: 'Reviewer',
    board: 'Board Member',
    viewer: 'Viewer',
};
/** Roles allowed to write general content collections (grants, deadlines, tasks...). */
export const EDIT_ROLES = ['a', 'e'];
/** Roles allowed on financial collections (transactions, disbursements, donors, receipts). */
export const FINANCE_ROLES = ['a', 'f'];
/** Roles allowed to capture evidence in the field. */
export const FIELD_ROLES = ['a', 'e', 'd'];
